import { supabase } from './supabase';
import type { AgentSettings } from '../types';
import { listMySubBrands, type SubBrand } from '@rehub/branding';

export const DEFAULT_SETTINGS: Omit<AgentSettings, 'agent_id' | 'created_at' | 'updated_at'> = {
  agency_name: '',
  agent_full_name: '',
  contact_email: '',
  contact_phone: '',
  logo_url: '',
  primary_color: '#0f172a',
  testimonials: [],
  recent_sold: [],
  notification_email: '',
  sub_brand_id: null,
};

/**
 * List sub-brands the doorsteps agent can pick from for their landing pages.
 * Returns an empty list when the user is solo (no team).
 */
export async function listAgentSubBrands(): Promise<SubBrand[]> {
  return listMySubBrands(supabase);
}

export async function getAgentSettings(agentId: string): Promise<AgentSettings | null> {
  const { data, error } = await supabase
    .from('doorsteps_agent_settings')
    .select('*')
    .eq('agent_id', agentId)
    .maybeSingle();
  if (error) return null;
  return data as AgentSettings | null;
}

export async function upsertAgentSettings(
  agentId: string,
  patch: Partial<AgentSettings>
): Promise<AgentSettings> {
  const merged: any = {
    ...DEFAULT_SETTINGS,
    ...patch,
    agent_id: agentId,
    updated_at: new Date().toISOString(),
  };
  const { data, error } = await supabase
    .from('doorsteps_agent_settings')
    .upsert(merged, { onConflict: 'agent_id' })
    .select('*')
    .single();
  if (error) throw error;
  return data as AgentSettings;
}
